import React, { useEffect } from "react";
import { bool, array } from "prop-types";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router";

import AppPage from "..";
import { connectToState } from "../../../redux/connect-api";
import { comingSoonSelector } from "../../../selectors";
import ComingSoonCard from "./ComingSoonCard";
import ProgressIndicator from "../../ProgressIndicator";
import AppPageContentWrapper from "../AppPageContentWrapper";
import { APP_TITLE } from "../../../constants";
import useUserHasAccess from "../../../hooks/useUserHasAccess";
import AccessFlag from "../../AccessFlag";

const ComingSoon = ({ loading, comingSoonItems }) => {
  const userHasAccess = useUserHasAccess();
  useEffect(() => {
    document.title = `${APP_TITLE} - Coming Soon`;
  }, []);

  if (loading) {
    return <ProgressIndicator active />;
  }

  if (!userHasAccess) {
    return <AccessFlag toolName="Coming Soon" />;
  }

  return (
    <AppPage title="Coming Soon" loading={loading}>
      <AppPageContentWrapper>
        {!comingSoonItems.length && (
          <Box sx={{ alignItems: "center", display: "flex", flexDirection: "column" }}>
            <Typography variant="h3" component="h2" style={{ marginBottom: 10 }}>
              There are currently no report snapshots or webinars planned for the immediate future.
            </Typography>
            <Typography>
              Check out our archived <Link to="/report-snapshots">report snapshots</Link> or{" "}
              <Link to="/webinars">webinars</Link> in the meantime.
            </Typography>
          </Box>
        )}
        {!!comingSoonItems.length && (
          <Box sx={{ display: "flex", flexDirection: "column", gap: "30px" }}>
            {comingSoonItems.map((item, i) => (
              <ComingSoonCard
                key={`coming-soon-item-${i}`}
                drugs={item.drugs}
                title={item.title}
                resource={item.resource}
                report={item.report}
              />
            ))}
          </Box>
        )}
      </AppPageContentWrapper>
    </AppPage>
  );
};

ComingSoon.propTypes = {
  loading: bool,
  comingSoonItems: array,
};

const mapStateToProps = (state) => {
  return {
    loading: state.userProfile.loading || state.comingSoon.loading,
    comingSoonItems: comingSoonSelector(state),
  };
};

export default connectToState(mapStateToProps)(ComingSoon);
